import * as HEALTH_TYPES from '../../actions/health/types';

const DEFAULT_STATE = {
    status: false,
};

export const payProReducer = (state = DEFAULT_STATE, action) => {
    const { type, payload } = action;
    switch (type) {
        case (HEALTH_TYPES.PAY_PRO_STATUS_SET):
            return {
                ...state,
                status: payload.status,
            };
        default:
            return state;
    }
};
